<template>
  <div class="page page__list">
    <search-bar @search="onSearch" name="cu_name,cu_sellername" placeholder="输入客户名称、业务员进行查找" ref="searchBar" />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div
        class="weui-cell weui-cell_access"
        v-for="(item, index) in items"
        :key="index"
        @click="gotoView(item)"
      >
        <div class="weui-cell__bd">
          <p>{{item.cu_name}}</p>
          <p class="list-item-muted">{{item.cu_sellername}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.cm_currency}}</p>
          <p class="list-item-muted" v-format="'#,##0.00'">{{item.cm_end}}</p>
        </div>
      </div>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">共：{{items.length}}笔</label>
      <em class="list-footer__value">
        合计：
        <span v-format="'#,##0.00'">{{getTotal()}}</span>元
      </em>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/ledger/cust_month/list",
      params: {
        mode: "DETAIL",
        number: 1,
        size: 99999,
        calculateFields: JSON.stringify([
          {"field":"cm_currency","operation":"max"},
          {"field":"cm_end","operation":"sum"}
        ]),
        page: 1,
        start: 0,
        limit: 99999
      },
      filters: [
        {
          type: "period",
          name: "cm_yearmonth"
        },
        {
          type: "currency",
          name: "cm_currency"
        },
        { 
          type: "seller",
          name: "cu_sellername",
        },
      ],
    };
  },
  methods: {
    gotoView(item) {
      this.$router.push({
        name: "MoneyTotalrecdetailReportDetail",
        params: {
          initData: Object.assign({}, item),
        },
      });
    },
    getTotal() {
      var me = this,
        items = me.items,
        total = 0
      items.forEach((item) => {
        total += item.cm_end;
      });
      return total;
    }
  },
};
</script>